<script>
	import Voucher from './voucher.svelte'
	
	export let reserva = {}
	let imprimir = false

</script>


<section class="p-2 mb-2">
	<div class="row">
		<div class="col-auto">{reserva.Hotel}</div>
		<div class="col-auto">{(reserva.Adultos+reserva.Menores) + 'PAX('+reserva.Menores+'Men)'}</div>
		<div class="col-auto">
			<i>IN</i>: {reserva.Llegada.substr(0,10).split('-').reverse().join('-')}&nbsp;&nbsp;
			<i>OUT</i>: {reserva.Salida.substr(0,10).split('-').reverse().join('-')}
		</div>
		<div class="col">#{reserva.Voucher} &nbsp;&nbsp; {reserva.FechaReserva.substr(0,10)} {reserva.FechaReserva.substr(11,8)}</div>
	</div>
	<div class="row">
		<div class="col-12">HUESPED : {reserva.ClienteUsuario}</div>
	</div>
	<div class="row  pb-1 border-bottom">
		<div class="col-auto">{reserva.TipoAgente}</div>
		<div class="col-auto">{reserva.EstadoVoucher}</div>
		<div class="col-auto">
			<b>VOUCHER</b> : {reserva.IdNroVoucher||'No emitido'}
			{(reserva.FechaVoucher||'').substr(0,10)}
		</div>
		<div class="col-auto">
			<button class="btn btn-sm btn-link" 
					disabled={parseInt(reserva.IdNroVoucher)<1 || reserva.Llegada<(new Date())}
					on:click={()=>imprimir=true}>
				Imprimir
			</button>
		</div>
		<details>
			<summary class="text-primary">Detalles</summary>
			<div  style="max-height: 200px;overflow: auto;">
				<pre>{JSON.stringify(reserva,null,2)}</pre>
			</div>
		</details>
	</div>
</section>


{#if imprimir}
	<Voucher item={reserva}><button on:click={()=>imprimir=false}>Cerrar</button></Voucher>
{/if}


<style>
	*{
		font-size: 0.95em;
	}
	section:hover{
		background-color: #DDDDDD;
	}
</style>